import createIcon from "components/elements/Icons/create-icon";

export default createIcon("BarChart", [
  [
    "path",
    {
      d: "M18 3.5C18.2762 3.5 18.5 3.72386 18.5 4V20C18.5 20.2762 18.2762 20.5 18 20.5C17.7238 20.5 17.5 20.2762 17.5 20V4C17.5 3.72386 17.7238 3.5 18 3.5ZM12 9.5C12.2762 9.5 12.5 9.72386 12.5 10V20C12.5 20.2762 12.2762 20.5 12 20.5C11.7238 20.5 11.5 20.2762 11.5 20V10C11.5 9.72386 11.7238 9.5 12 9.5ZM6 15.5C6.27614 15.5 6.5 15.7238 6.5 16V20C6.5 20.2762 6.27614 20.5 6 20.5C5.72386 20.5 5.5 20.2762 5.5 20V16C5.5 15.7238 5.72386 15.5 6 15.5Z",
    },
  ],
]);
